import { createActionGroup, props } from '@ngrx/store';
import { YearOfStudy } from '../../services/model/year-of-study';
import { ReferenceDataEstablishment } from '../../services/model/reference-data';

export const ReferenceDataActions = createActionGroup({
  source: 'Reference Data',
  events: {
    'Years Of Study Loaded': props<{ yearOfStudy: YearOfStudy[] }>(),
    'Establishments Loaded': props<{ establishments: ReferenceDataEstablishment[] }>(),
  },
});